import React from "react";

export const quantityLarger = (number) => {
	return number > 200 ? "200+ xe" : `${number} xe`;
};

export const VehicleCheckBox = ({ option, name, onVTypeChange }) => {
	const idxName = option.name.indexOf('(')
	let vTypeName = option.name
	let subName = "";
	if (idxName !== -1) {
		vTypeName = option.name.slice(0, idxName)
		subName = option.name.slice(idxName)
	}

	
	return (
		<div className="custom-checkbox-selected" key={option.id}>
			<input type="checkbox" id={name} onChange={onVTypeChange} value={option.id} checked={option.checked} />
			<label htmlFor={name}>
				<div className="vehicle-types__item">
					<div className="vehicle-types__item--img">
						<img loading="lazy" src={option.logo} />
					</div>
					<p className="name">{vTypeName}
						{subName !== "" ? <span>{subName}</span> : null}
					</p>
					{option.counter > 0 ? <p className="total">{quantityLarger(option.counter)}</p> : null }
				</div>
			</label>
		</div>
	);
};

export const MVehicleCheckBox = ({ option, name, onVTypeChange }) => {
	return (
		<div className="custom-checkbox-selected" key={option.id}>
			<input type="checkbox" id={name} onChange={onVTypeChange} value={option.id} checked={option.checked} />
			<label htmlFor={name}>
				<div className="vehicle-swiper">
					<img loading="lazy" src={option.logo} />
					<p>{option.name}</p>
					<p>{option.counter > 0 ? quantityLarger(option.counter) : ""} </p>
				</div>
			</label>
		</div>
	);
};

export const VehicleRadio = ({ vehicles, onChange, vehicleMake, name }) => {
	return (
		<>
			<div className="custom-radio">
				<input
					type="radio"
					id={`r_vm0${name}`}
					checked={vehicleMake == 0}
					name={`r_vMake${name}`}
					value={"0"}
					onChange={() => onChange(0)}
				/>
				<label htmlFor={`r_vm0${name}`}>Tất cả</label>
			</div>
			{vehicles &&
				vehicles.map((vehicle) =>
					vehicle.counter > 0 ? (
						<div className="custom-radio" key={vehicle.id}>
							<input
								type="radio"
								id={`r_vm${vehicle.id}${name}`}
								name={`r_vMake${name}`}
								checked={vehicleMake == vehicle.id}
								value={vehicle.id}
								onChange={() => onChange(vehicle.id)}
							/>
							<label htmlFor={`r_vm${vehicle.id}${name}`}>
								<img loading="lazy" src={vehicle.logo} alt={vehicle.name} />
								<p>
									{vehicle.name} <span className="note"> ({quantityLarger(vehicle.counter)})</span>
								</p>
							</label>
						</div>
					) : null
				)}
		</>
	);
};

export const VModelCheckBox = ({ vehicles, onChange }) => {
	return (
		<>
			{vehicles &&
				vehicles.map((vehicle) => {
					return vehicle.counter > 0 ? (
						<div key={vehicle.id} className={`custom-checkbox-selected`}>
							<input
								type="checkbox"
								id={`cb_MD${vehicle.id}`}
								name={`cb_vmd${vehicle.id}`}
								value={vehicle.id}
								checked={vehicle.checked}
								onChange={(e) => onChange(e)}
							/>
							<label htmlFor={`cb_MD${vehicle.id}`}>
								{vehicle.name}
								<span className="note"> ({quantityLarger(vehicle.counter)})</span>
							</label>
						</div>
					) : null;
				})}
		</>
	);
};

export const FeaturesCheckBox = ({ id, options, onOptionChange, register }) => {
	return (
		<React.Fragment>
			{options &&
				options.map((option) => {
					return (
						<div className={`have-label ${register ? "squaredThree" : "squaredTwo"}`} key={option.id}>
							<input
								id={`${id}-${option.id}`}
								type="checkbox"
								checked={!!option.checked}
								value={option.id}
								onChange={onOptionChange}
								name="filter-car-feature"
							/>
							<label className="description" htmlFor={`${id}-${option.id}`}>
								<div className="thumbnail">
									<img loading="lazy" className="img-fluid" src={option.logo} alt={option.name} />
									<span>{option.name}</span>
								</div>
							</label>
						</div>
					);
				})}
		</React.Fragment>
	);
};

export const CheckBoxFilter = ({ id, options, onOptionChange }) => {
	return (
		<React.Fragment>
			{options &&
				options.map((option) => {
					return (
						<div className={`custom-checkbox-selected`} key={option.id}>
							<input
								id={`${id}-${option.id}`}
								type="checkbox"
								checked={!!option.checked}
								value={option.id}
								onChange={onOptionChange}
								name="filter-car-feature"
							/>
							<label htmlFor={`${id}-${option.id}`}>{option.name}</label>
						</div>
					);
				})}
		</React.Fragment>
	);
};
